const resumeEntries = [
  {
    year: "2012",
    title: "studies",
    company: "FH Krefeld - Bachelor of Science",
    description: "Learned C / C++",
  },
  {
    year: "2015",
    title: "apprenticeship",
    company: "FLOWFACT GmbH",
    description:
      "Learned Java, Javascript, HTML, CSS, SQL and VB. Worked on the FLOWFACT Performer CRM software.",
  },
  {
    year: "2018",
    title: "Fullstack Developer Junior",
    company: "FLOWFACT GmbH",
    description:
      "Joined the hAPPy team. Worked on the FLOWFACT hAPPy product that was written in Java. Learned to host and maintain the project on a cloud server. Learnedto use Jenkins for CI/CD and Docker for containerization.",
  },
  {
    year: "2020",
    title: "Fullstack Developer Professional",
    company: "FLOWFACT GmbH",
    description:
      "By taking over internal project and with more and more responsibilities I was promoted to Fullstack Developer Professional. Moved projects to AWS. Worked on microservices and serverless architectures. Learned to work with MongoDB, dynamoDB, Redis and other databases.",
  },
  {
    year: "2023 - today",
    title: "Senior Platform Developer",
    company: "FLOWFACT GmbH / Propstack GmbH",
    description:
      "Leading platform modernization and reliability initiatives. Building internal tooling, improving performance and optimizing cloud costs across services.",
  },
];

export default resumeEntries;
